module.exports = __webpack_public_path__ + "fonts/IndivisibleWebRegularItalic.6eaf1675.woff2";